export class UnmanagedDocument {
  constructor(
    public isQuotable: boolean,
    public alternativeFormatId: number,
  ) {}
}
